import React from "react";
import "./styles.css";

const HexCard = ({ className, children, onClick }) => {
  const hexCardProps = {
    ...(onClick && { onClick }),
  };

  return (
    <div className={`hex-card-container ${className}`} {...hexCardProps}>
      {children}
    </div>
  );
};

export default HexCard;
